import { SET_COUNTRY_CODE } from "../actionTypes/countyCodeActionTypes";

const initialState = "";

const countryCodeReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_COUNTRY_CODE:
            return action.payload;
        default:
            return state;
    }
};

export default countryCodeReducer;
